@if (data) {
  <div class="button-input">
    @if (data.data$|async; as supplier) {
      <input type="text"
        class="form-control"
        [ngClass]="{red_alert: supplier.date_deleted}"
        [value]="supplier.id+' - '+supplier.name"
        disabled>
      <button type="button" class="btn btn-default" (click)="modal(supplier)" [disabled]="disabled">
        <i class="fa fa-search-plus"></i>
      </button>
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }
    <loading-or-error
      #loadingOrError
      [loadingWrapper]="data"
      [errorMessage]="'Konnte Lieferant nicht laden'">
    </loading-or-error>
  </div>
}
@if (!data) {
  <div class="button-input">
    <input type="text" class="form-control" placeholder="Bitte Lieferanten wählen" disabled>
    <button type="button" class="btn btn-default" (click)="modal(null)">
      <i class="fa fa-search-plus"></i>
    </button>
  </div>
}
